import React, { useState } from "react";
import { InputTextBox } from "../../../../components";
import { SearchBlack } from "../../../../components/Icons/Icons";
import classNames from "classnames/bind";
import styles from "./Filter.module.css";
import DateTimePicker from "../../../../components/DateTimePicker/DateTimePicker";

const cx = classNames.bind(styles);
const Filter = ({
  onChangeDayEnd,
  onChangeDayStart,
  changeTextSearch,
  dayStart,
  dayEnd,
}) => {
  const ref = React.useRef();
  const [input, setInput] = useState();
  const onChangeTextSearch = (e) => {
    setInput(e.target.value);
    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      const data = e.target.value;
      changeTextSearch(data);
    }, 300);
  };
  return (
    <div className={cx("filter")}>
      <div className={cx("search")}>
        <input
          className={cx("search-input")}
          placeholder="Tìm kiếm..."
          value={input}
          onChange={onChangeTextSearch}
        />
        <span className={cx("icon-search")}>
          <SearchBlack />
        </span>
      </div>
      <div style={{ flex: 1, marginTop: '21px' }}>
        <DateTimePicker title={'Bắt đầu'} onChange={onChangeDayStart}/>
      </div>
      <div style={{ flex: 1, marginTop: '21px' }}>
        <DateTimePicker title={'Kết thúc'} onChange={onChangeDayEnd}/>
      </div>
    </div>
  );
};

export default Filter;
